import validate from "/Users/guilherme/www/ntask/financeiro/financeiro-front/node_modules/nuxt/dist/pages/runtime/validate.js";
import authorization_45global from "/Users/guilherme/www/ntask/financeiro/financeiro-front/middleware/authorization.global.ts";
import modal_45url_45global from "/Users/guilherme/www/ntask/financeiro/financeiro-front/middleware/modal-url.global.ts";
import manifest_45route_45rule from "/Users/guilherme/www/ntask/financeiro/financeiro-front/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  authorization_45global,
  modal_45url_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}